




















































































































import moment from 'moment'
import _ from 'lodash'
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AgendaGarantiaMinimaStore from '@/components/RemuneracaoMedica/financeiro/Store/AgendaGarantiaMinimaStore'
import AntecipacaoRecebiveisStore from '@/components/RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'
import EventBus from '@/plugins/EventBus'
import { IRequestMessage, MensagensDaApiEnum, RequestMessage } from '@/types/_'
import { formatDateOnly, maskMoney, timeout } from '@/utils/common'
import AntecipacaoForm from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/AntecipacaoForm.vue'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'

@Component({
  components: {
    AntecipacaoForm,
  }
})
export default class ViewFinanceiroAntecipacoesRecebiveis extends Vue {
  search: string = ''
  loadingSearch: boolean = false
  getRequestMessage: IRequestMessage = new RequestMessage()

  get situacoes() {
    return this.antecipacaoRecebiveisStore.situacoes
  }

  get antecipacaoRecebiveisStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Profissional', value: 'profissional', align: 'center', sortable: false },
      { text: 'Hospital', value: 'hospital', align: 'center', sortable: false },
      { text: 'Valor a receber', value: 'valorReceberProducao', align: 'center', sortable: false },
      { text: 'Recebível', value: 'recebivel', align: 'center', sortable: false },
      { text: 'Mediana dos recebíveis', value: 'medianaRecebiveis', align: 'center', sortable: false },
      { text: 'Valor sugerido', value: 'valorSugerido', align: 'center', sortable: false },
      { text: 'Valor ofertado', value: 'valorOfertado', align: 'center', sortable: false },
      { text: 'Valor solicitado', value: 'valorSolicitado', align: 'center', sortable: false },
      { text: 'Valor líquido antecipado', value: 'valorLiquidoAntecipado', align: 'center', sortable: false },
      { text: 'Próximo pagamento', value: 'proximoPagamento', align: 'center', sortable: false },
      { text: 'Situação', value: 'situacao', align: 'center', sortable: false },
      { text: 'Ações', value: 'actions', align: 'center', sortable: false },
    ]
  }

  get items() {
    return this.antecipacaoRecebiveisStore.antecipacoesList
  }

  get situacao() {
    return this.antecipacaoRecebiveisStore.filtroSituacao
  }

  set situacao(value: any) {
    this.antecipacaoRecebiveisStore.setFiltroSituacao(value)
  }
  
  get getPagina() {
    return this.antecipacaoRecebiveisStore.pagina
  }

  set getPagina(value: number) {
    this.antecipacaoRecebiveisStore.setPagina(value)
  }

  get itemsLength() {
    return Math.ceil(this.antecipacaoRecebiveisStore.totalRegistros / this.antecipacaoRecebiveisStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
    EventBus.$emit('clearLoadingRequest')
  }
  
  formatDate(date: any) {
    return formatDateOnly(date)
  }

  formatMoney(value: any) {
    return maskMoney(value)
  }

  async editar(item: any) {
    this.antecipacaoRecebiveisStore.setModalAntecipacaoForm(true)
    this.antecipacaoRecebiveisStore.setAntecipacaoId(item.antecipacaoId)
    await this.antecipacaoRecebiveisStore.getAntecipacaoById()
    await this.antecipacaoRecebiveisStore.getDadosBancarios()
  }

  showAdvancedFilters() {
    this.antecipacaoRecebiveisStore.setDrawer(!this.antecipacaoRecebiveisStore.drawer)
  }

  async clearAdvancedFilters() {
    this.antecipacaoRecebiveisStore.clearFiltroAvançado()
    this.antecipacaoRecebiveisStore.setFilterOn(false)
    this.antecipacaoRecebiveisStore.setDrawer(false)
    this.getPagina = 1
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
  }

  async filtrarPorSituacao() {
    this.getPagina = 1
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
  }

  searchDebounce = _.debounce((searchTerm: string) => {
    this.performSearch(searchTerm)
  }, 300)

  async performSearch(searchTerm: string) {
    this.loadingSearch = true

    // seta no store a string (não o evento)
    this.antecipacaoRecebiveisStore.setSearch(searchTerm)
    this.getPagina = 1

    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()

    this.loadingSearch = false
  }

  clearPrestadorSearch() {
    this.search = ''
    this.antecipacaoRecebiveisStore.setSearch('')
    this.performSearch('')
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
    await this.antecipacaoRecebiveisStore.getSituacoes()
    await this.antecipacaoRecebiveisStore.getBancos()
    await this.antecipacaoRecebiveisStore.getTiposPix()
    await this.antecipacaoRecebiveisStore.getLocaisExecucaoList()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

}
